var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff715d;}.cls-2{fill:#be5521;}.cls-3{fill:#2ca0ff;}.cls-4{fill:#ffbe9f;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-7{clip-path:url(#clip-path-2);}.cls-8{clip-path:url(#clip-path-3);}.cls-9{clip-path:url(#clip-path-4);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.16,776.89c-24,.47-45.47-11.83-54.81-31.4-8.63-18.1-3.65-35.72-2.11-40.53-40-32.79-89.39-86.65-134.16-161-53.41-88.7-96.32-208.36-68.37-344.31,14.8-72,71-128.9,143.41-141.82a169.82,169.82,0,0,1,79.56,4.44c2.85.87,5.63,1.8,8.36,2.8,73.82,27,110.48,109.55,83.24,183.28-14.38,38.91-26.23,93.42-16.43,157.16,8.65,56.3,34.77,118.77,92.63,181.14,2.9.58,26,5.54,37.46,28,10,19.6,3.92,38.28,2.77,41.64L409.16,776.89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M415.27,793c-25.19-58.29,1-126.38,57.13-152.38,58-26.9,129.39-.12,155.64,60.14,90,113.52,99.28,198.65,65.46,235.48-8.37,9.12-21.09,15.14-39.32,16.85,0,0-20.29,30.93-52,12.64,0,0-21.81,32.79-57.83-13.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M691.78,750.22s252.84-37.62,431.74-230.64C1195.47,442,1323.7,458.8,1372,553c.57,1.1,1.12,2.21,1.67,3.32,25.42,52.15,24.58,113.32-.52,165.75a150.56,150.56,0,0,1-36.37,47.8c-43.91,38.7-104.44,81.08-180.68,118.5C1034.57,948,868.79,1001.7,687,942.91c9.41-12.71,20.55-41.81,26.65-69.17C727.18,812.93,699.72,763.46,691.78,750.22Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M507,796.3c-23.74-27.85-61.88-32.85-84.62-17.22-27.17,18.69-33.88,67.9-2.06,100.3A37.89,37.89,0,0,0,476.78,919c-3.52,19.85,7.5,39,25,45.2,14.63,5.22,31.63.61,42.65-11.7l.12-.34a197.47,197.47,0,0,1,35.71-60.85l.48-.56A36.72,36.72,0,0,0,534,835.23c.63-1.82,4.22-12.78-1.79-23.77C524.4,797.21,507.81,796.33,507,796.3Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "handshake") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.16,776.89c-24,.47-45.47-11.83-54.81-31.4-8.63-18.1-3.65-35.72-2.11-40.53-40-32.79-89.39-86.65-134.16-161-53.41-88.7-96.32-208.36-68.37-344.31,14.8-72,71-128.9,143.41-141.82a169.82,169.82,0,0,1,79.56,4.44c2.85.87,5.63,1.8,8.36,2.8,73.82,27,110.48,109.55,83.24,183.28-14.38,38.91-26.23,93.42-16.43,157.16,8.65,56.3,34.77,118.77,92.63,181.14,2.9.58,26,5.54,37.46,28,10,19.6,3.92,38.28,2.77,41.64L409.16,776.89"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362.25,694.58s44.29-89,141.51-95.39"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M415.27,793c-25.19-58.29,1-126.38,57.13-152.38,58-26.9,129.39-.12,155.64,60.14,90,113.52,99.28,198.65,65.46,235.48-8.37,9.12-21.09,15.14-39.32,16.85,0,0-20.29,30.93-52,12.64,0,0-21.81,32.79-57.83-13.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M630.73,845.14a178.2,178.2,0,0,1,19.71,129.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M579.6,891.65c22.75,25.47,30.76,63.26,20.29,95.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M617.37,853.2a41.78,41.78,0,0,1,31.33-15.57"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M691.78,750.22s252.84-37.62,431.74-230.64C1195.47,442,1323.7,458.8,1372,553c.57,1.1,1.12,2.21,1.67,3.32,25.42,52.15,24.58,113.32-.52,165.75a150.56,150.56,0,0,1-36.37,47.8c-43.91,38.7-104.44,81.08-180.68,118.5C1034.57,948,868.79,1001.7,687,942.91c9.41-12.71,20.55-41.81,26.65-69.17C727.18,812.93,699.72,763.46,691.78,750.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M777.38,755.5s81.38,79.38-7.63,178.78"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M687,942.91c47.32-3.73,84.3-41.63,89.74-87.77C782.39,807,751,760.82,703,748.23c-8.39-14.58-20.33-31.79-39.87-43-28.93-16.52-76.83-25.63-153.6,1.7-12.67,4.52-20.61,17.46-18.11,30.68,3.34,17.6,25.07,37.27,107,35.23,0,0,21.76,55.68,87.38,27.84a119.2,119.2,0,0,1,22,53.4C714.18,899.18,693,934.37,687,942.91Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M507,796.3c-23.74-27.85-61.88-32.85-84.62-17.22-27.17,18.69-33.88,67.9-2.06,100.3A37.89,37.89,0,0,0,476.78,919c-3.52,19.85,7.5,39,25,45.2,14.63,5.22,31.63.61,42.65-11.7l.12-.34a197.47,197.47,0,0,1,35.71-60.85l.48-.56A36.72,36.72,0,0,0,534,835.23c.63-1.82,4.22-12.78-1.79-23.77C524.4,797.21,507.81,796.33,507,796.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M547.6,822.59a208.36,208.36,0,0,0-82.29,131.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M415.93,903.49A132.95,132.95,0,0,1,532.53,789"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake01);
export default __webpack_public_path__ + "static/media/handshake-01.d784d740d188ad4106356947d00b16ff.svg";
export { ForwardRef as ReactComponent };